import { useEffect, useState } from "react";

export default function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const progress = docHeight > 0 ? scrollTop / docHeight : 0;
      setScrollProgress(progress);
      setVisible(scrollTop > 400);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const radius = 18;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference * (1 - scrollProgress);

  return (
    <button
      onClick={handleClick}
      aria-label="トップへ戻る"
      className="fixed bottom-6 right-6 cursor-pointer"
      style={{
        width: 48,
        height: 48,
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0) scale(1)" : "translateY(16px) scale(0.85)",
        transition: "opacity 0.35s cubic-bezier(0.23,1,0.32,1), transform 0.35s cubic-bezier(0.23,1,0.32,1)",
        pointerEvents: visible ? "auto" : "none",
        zIndex: 40,
      }}
    >
      {/* Progress ring SVG */}
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        style={{ position: "absolute", top: 0, left: 0, transform: "rotate(-90deg)" }}
      >
        {/* Track */}
        <circle
          cx="24"
          cy="24"
          r={radius}
          fill="none"
          stroke="rgba(212,163,115,0.15)"
          strokeWidth="1.5"
        />
        {/* Progress */}
        <circle
          cx="24"
          cy="24"
          r={radius}
          fill="none"
          stroke="#D4A373"
          strokeWidth="1.5"
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          strokeLinecap="round"
          style={{ transition: "stroke-dashoffset 0.1s linear" }}
        />
      </svg>

      {/* Inner circle + arrow */}
      <div
        className="absolute inset-1 flex items-center justify-center"
        style={{
          background: "rgba(20,20,20,0.92)",
          backdropFilter: "blur(8px)",
          border: "1px solid rgba(212,163,115,0.2)",
          borderRadius: "50%",
        }}
      >
        <i
          className="ri-arrow-up-line text-[#D4A373]"
          style={{ fontSize: 14 }}
        />
      </div>
    </button>
  );
}
